/* eslint-disable react/function-component-definition */
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useQuery } from '@apollo/client';
function ErrorController(_ref) {
  var children = _ref.children,
    query = _ref.query,
    context = _ref.context,
    variables = _ref.variables,
    apolloClient = _ref.apolloClient,
    handler = _ref.handler;
  var _useQuery = useQuery(query, {
      context: context,
      variables: variables,
      client: apolloClient
    }),
    loading = _useQuery.loading,
    error = _useQuery.error,
    data = _useQuery.data;
  return /*#__PURE__*/React.createElement(React.Fragment, null, handler(loading, error, data) || children);
}
export default ErrorController;
//# sourceMappingURL=index.js.map